// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aime_9a2ee0', '__aime_Fallback_9a2ee0'"},"className":"__className_9a2ee0","variable":"__variable_9a2ee0"};